import React from 'react'
import About from './About'
import Home from './Home'
import { BrowserRouter } from 'react-router-dom'
import { Switch } from 'react-router'
import { Route } from 'react-router-dom'
import './index.css'
import Writing from './Writing'
import Contact from './Contact'
import Research from './Research'
import { isMobile } from 'react-device-detect';

function App() {

  const hrs = new Date().getHours();
  var darkMode = (hrs < 7 || hrs >= 19) && !isMobile;
  darkMode ? document.body.style = 'background: #222222;' : document.body.style = 'background: white;';

  return (
    <div>
      <BrowserRouter>
        <div style={{ color: darkMode ? "white" : "black", margin: "0 auto", textAlign: "left", maxWidth: isMobile ? "90%" : "85%", display: "flex", justifyContent: "center" }}>
          <Switch>
            <Route exact path="/">
              <About />
            </Route>
            <Route path="/writing">
              <Writing />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
            <Route path="/research">
              <Research />
            </Route>
          </Switch>
        </div>
      </BrowserRouter>
    </div>
  )
}

export default App